import React from 'react';
import { AuthorType } from '../../models';
import { block } from '../../utils';
import { Image } from '../index';
import './Author.css';
const b = block('author');
const Author = (props) => {
    const { author, className, authorContainerClassName, type = AuthorType.Column, dataQa } = props;
    const { firstName, secondName, description, avatar } = author;
    const name = secondName ? `${firstName} ${secondName}` : firstName;
    return (React.createElement("div", { className: b({ type }, className), "data-qa": dataQa },
        avatar && (React.createElement("div", { className: b('avatar', authorContainerClassName) }, typeof avatar === 'string' ? React.createElement(Image, { src: avatar }) : avatar)),
        React.createElement("div", { className: b('label') },
            React.createElement("div", { className: b('name') }, name),
            description && React.createElement("div", { className: b('description') }, description))));
};
export default Author;
